import { create } from "zustand";

interface AddAddressStore {
    isOpen: boolean;
    isComplete: boolean;
    open: () => void;
    close: () => void;
    markComplete: () => void;
    reset: () => void;
}

const useAddAddressModal = create<AddAddressStore>((set) => ({
    isOpen: false,
    isComplete: false,
    open: () => set({ isOpen: true, isComplete: false }),
    close: () => set({ isOpen: false }),
    markComplete: () => set({ isComplete: true }),
    reset: () => set({ isOpen: false, isComplete: false }),
}));

export default useAddAddressModal;